import { FC, useEffect, useState, useRef } from "react";
import { Button, notification} from "antd";
import TableComponent from "./table/table";
import { PlusCircleOutlined } from "@ant-design/icons";
import UserManagementService from "../../../../services/user-managament.service";
import FormModal from "./formModal/formModal";
import { cloneDeep } from "lodash";
import { compareArrays, emailValidationWithAllowedDomains, genderValidation, getAllowedDomains, inputValidation, phoneNumberValidation, primaryOfficeValidation ,secondaryOfficeValidation } from "@utils/helpers";
import "./userManagment.scss"
import { useUserManagement } from "@stores/userManagmentStore";
import ModalCustom from "@components/modal-custom";
import { CanEdit } from '@components/accessLevel'
const UserManagement: FC<any> = (props) => {
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState<boolean>(false);
  const [isEditUserModalOpen, setisEditUserModalOpen] = useState<boolean>(false);
  const [createUserFields, setCreateUserFields] = useState<any>([]);
  const [editUserFields, setEditUserFields] = useState<Array<any>>([]);
  const [usersData, setUsersData] = useState<Array<any>>([]);
  const [editRowData, setEditRowData] = useState<any>({});

  const [columnData, setColumnData] = useState<any>([]);
  const [dropdownData, setDropdownData] = useState<any>([]);
  const multiDropDowns = useRef<string[]>([]);
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const [allowedDomains, setallowedDomains] = useState<string[]>([]);
  const [patientAssignmentDisabled , setPatientAssignmentDisabled] = useState<boolean>(false);
  const formValidationError = useRef<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const userRole = useUserManagement((state) => state.userRole);

  useEffect(() => {
    console.log("userManagment.useEffect1")
    if(userRole){
      getUsersData();
      getColumnData();
      getAllowedDomains(setallowedDomains);
      getAssignmentStatus();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole]);

  useEffect(() => {
    console.log("userManagment.useEffect2")
    let interval = setInterval(() => {
      getAssignmentStatus();
    } , 120000)

    return () => {
      clearInterval(interval);
    };
  } , [])

  const getAssignmentStatus = () => {
    console.log("userManagment.getAssignmentStatus")
    UserManagementService.getAssignmentStatus().subscribe({
      next: (res: any) => {
        const response = res.data.data;
        setPatientAssignmentDisabled(response === "InComplete" ? true : false);
      },
      error: () => {
        console.log("error");
      },
    });
  }

  const getDropdownData = (columndata : any) => {
    console.log("userManagment.getDropdownData")
   const dropdowns: string[] = [];
    if (columndata.length > 0) {
      columndata?.forEach((ob: any) => {
        if (ob?.type?.includes("DRPDWN")) {
          dropdowns.push(ob.dataIndex);
          if (ob?.type?.includes("MSELDRPDWN")) {
            multiDropDowns.current.push(ob.dataIndex);
          }
        }
      });
    }
    const data = {
      pageName: "User Mgmt",
      dropDownNames: dropdowns,
    };
    if (dropdowns.length > 0) {
      UserManagementService.getDropdownData(data).subscribe({
        next: (res: any) => {
          const response = res.data.data;
          let dropdowns = [];
          for (let i = 0; i < response.dropdownsFetched.length; i++) {
            if(response.dropdownsFetched[i] === 'user_role'){
              if(userRole !== 'SysAdmin'){
                const index = response.response[i].findIndex((val : any) => val.value === 'SysAdmin');
                if (index > -1) {
                  response.response[i].splice(index, 1); 
                }
              }
            }
            dropdowns.push({ dropdownName: response.dropdownsFetched[i], data: ['office_name' , 'secondary_office_name'].includes(response.dropdownsFetched[i]) ? [{ value: "ALL", title: "Select ALL" }].concat(response.response[i]) : response.response[i] });
          }
          setDropdownData(dropdowns);
        },
        error: () => {
          console.log("error");
        },
      });
    }
  }
  
  const getColumnData = () => {
    console.log("userManagment.getColumnData")
    UserManagementService.getColumnsList().subscribe({
      next: (res: any) => {
        const columndata = res.data.data.columns;
        columndata.forEach((col : any) => {
          if(col.type === 'ACTN-RADIO'){
            if(col.dataIndex === 'user_gender') {
              col.possibleValues = ['M' , 'F']
          }
          }
        })
        setColumnData(columndata);
        getDropdownData(columndata);
        const createFields: Array<any> = [];
        const editFields: Array<any> = [];
        columndata.forEach((col: any) => {
          if(col.type){
            if(['email_type'].includes(col.dataIndex)){
              col.required = false;
            } else if(!['office_name' , 'secondary_office_name'].includes(col.dataIndex)){
              col.required = true;
            }
            createFields.push({ ...col });
            if(!col.type.includes("NEDIT")) {
              editFields.push({ ...col });
            }
          }
        })
        setCreateUserFields(createFields);
        setEditUserFields(editFields);
      },
      error: () => {
        console.log("error");
      },
    });
  };

  const formHasError = (data : any) => {
    console.log("userManagment.formHasError")
    let hasError = false; 
    for(let i = 0 ; i < data.length ; i ++){
      if(data[i]?.errorMessage?.length > 0) {
        hasError = true;
        break; 
      }
    }
    return hasError;
  }

  const onUserFieldChange = (value: any, field: any, action: string) => {
    console.log("userManagment.onUserFieldChange")
    if (action === "ADD") {
      const data = cloneDeep(createUserFields);
      data[data.findIndex((col: any) => col.dataIndex === field.dataIndex)].value = value;
      const errorMessage = validateField(data , data[data.findIndex((col: any) => col.dataIndex === field.dataIndex)]);
      data[data.findIndex((col: any) => col.dataIndex === field.dataIndex)].errorMessage = errorMessage;
      const secondaryOfficeIndex = data.findIndex((col: any) => col.dataIndex === 'secondary_office_name');
      if(field.dataIndex === 'user_role'){
        if(['ReportUser','ReportUserAdmin'].includes(value)){
          data[secondaryOfficeIndex].className = '';
          data[secondaryOfficeIndex].errorMessage = '';
        } else if(data.find((col: any) => col.dataIndex === 'office_name').value === 'ALL'){
          data[secondaryOfficeIndex].className = 'dnone';
          data[secondaryOfficeIndex].value = '';
          data[secondaryOfficeIndex].errorMessage = '';
        } else {
          data[secondaryOfficeIndex].errorMessage = validateField(data , data[data.findIndex((col: any) => col.dataIndex === 'secondary_office_name')]);
        }
      }else if(field.dataIndex === 'secondary_office_name'){
        const errorMessage = validateField(data , data[data.findIndex((col: any) => col.dataIndex === 'office_name')]);
        data[data.findIndex((col: any) => col.dataIndex === 'office_name')].errorMessage = errorMessage; 
      }else if(field.dataIndex === 'office_name'){
        const secondaryOfficeIndex = data.findIndex((col: any) => col.dataIndex === 'secondary_office_name');
        if(value === 'ALL' && !['ReportUser','ReportUserAdmin'].includes(data.find((d : any) => d.dataIndex === 'user_role')?.value)){
          data[secondaryOfficeIndex].value = '';
          data[secondaryOfficeIndex].className = 'dnone';
          data[secondaryOfficeIndex].errorMessage = '';
        } else {
          data[secondaryOfficeIndex].className = '';
          const errorMessage = validateField(data , data[data.findIndex((col: any) => col.dataIndex === 'secondary_office_name')]);
          data[data.findIndex((col: any) => col.dataIndex === 'secondary_office_name')].errorMessage = errorMessage;
        }
      }
      formValidationError.current = formHasError(data);
      setCreateUserFields(data);
    } else if (action === "EDIT") {
      const data = cloneDeep(editUserFields);
      data[data.findIndex((col: any) => col.dataIndex === field.dataIndex)].value = value;
      const errorMessage = validateField(data , data[data.findIndex((col: any) => col.dataIndex === field.dataIndex)]);
      data[data.findIndex((col: any) => col.dataIndex === field.dataIndex)].errorMessage = errorMessage;
      const secondaryOfficeIndex = data.findIndex((col: any) => col.dataIndex === 'secondary_office_name');
      if(field.dataIndex === 'user_role'){
        if(['ReportUser','ReportUserAdmin'].includes(value)){
          data[secondaryOfficeIndex].className = '';
        } else if(data.find((col: any) => col.dataIndex === 'office_name').value === 'ALL'){
          data[secondaryOfficeIndex].className = 'dnone';
          data[secondaryOfficeIndex].value = '';
          data[secondaryOfficeIndex].errorMessage = '';
        } else {
          data[secondaryOfficeIndex].errorMessage = validateField(data , data[data.findIndex((col: any) => col.dataIndex === 'secondary_office_name')]);
        }
      }else if(field.dataIndex === 'secondary_office_name'){
        const errorMessage = validateField(data , data[data.findIndex((col: any) => col.dataIndex === 'office_name')]);
        data[data.findIndex((col: any) => col.dataIndex === 'office_name')].errorMessage = errorMessage; 
      }else if(field.dataIndex === 'office_name'){
        const secondaryOfficeIndex = data.findIndex((col: any) => col.dataIndex === 'secondary_office_name');
        if(value === 'ALL' && !['ReportUser','ReportUserAdmin'].includes(data.find((d : any) => d.dataIndex === 'user_role')?.value)){
          data[secondaryOfficeIndex].value = '';
          data[secondaryOfficeIndex].className = 'dnone';
          data[secondaryOfficeIndex].errorMessage = '';
        } else {
          data[secondaryOfficeIndex].className = '';
          const errorMessage = validateField(data , data[data.findIndex((col: any) => col.dataIndex === 'secondary_office_name')]);
          data[data.findIndex((col: any) => col.dataIndex === 'secondary_office_name')].errorMessage = errorMessage;
        }
      }
      formValidationError.current = formHasError(data);
      setEditUserFields(data);
    }
  };

  const getUsersData = () => {
    console.log("userManagment.getUsersData")
    UserManagementService.getUsersData().subscribe({
      next: (res: any) => {
        setUsersData(res.data.data);
      },
      error: () => {
        console.log("error");
      },
    });
  };

  const formatUserData = (data: any, action: string) => {
    console.log("userManagment.formatUserData")
    const obj: any = {};
    data.forEach((col: any) => {
      if (multiDropDowns.current.includes(col.dataIndex) && col.value) {
        obj[col.dataIndex] = col.value.split("$|").join(",");
      } else {
        obj[col.dataIndex] = col.value;
      }
    });

    if (action === "EDIT") {
      obj["user_email"] = editRowData["user_email"];
      obj["patient_asgmt_status"] =  (!compareArrays(obj["office_name"]?.split(",") , editRowData["office_name"]?.split("$|")) || !compareArrays(obj["secondary_office_name"]?.split(",") , editRowData["secondary_office_name"]?.split("$|"))) ? 'Y' : 'N';
    }
    return obj;
  };

  const validateField = (data : any , col: any) => {
    console.log("userManagment.validateField")
    let errorMessage = '';
    if (col.type.includes("ACTN-FREETXT") && ["user_first_name", "user_last_name"].includes(col.dataIndex)) {
      errorMessage = inputValidation(col.value, col.displayName);
    } else if (col.type.includes("ACTN-FREETXT-NEDIT") && ["user_email"].includes(col.dataIndex)) {
      errorMessage = emailValidationWithAllowedDomains(col.value, col.displayName, allowedDomains , usersData);
    } else if (col.type.includes("ACTN-PHONE") && ["user_phone_number"].includes(col.dataIndex)) {
      errorMessage = phoneNumberValidation(col.value, col.displayName);
    } else if (col.type.includes("ACTN-RADIO")) {
      errorMessage = genderValidation(col.value, col.displayName , col.possibleValues);
    } else if (col.type.includes("DRPDWN") && ["lob_name", "user_role"].includes(col.dataIndex)) {
      errorMessage = inputValidation(col.value, col.displayName);
    } else if(col.type.includes("DRPDWN") && ["office_name"].includes(col.dataIndex)){
      errorMessage = primaryOfficeValidation(col.value, col.displayName , data.find((d : any) => d.dataIndex === 'secondary_office_name') , data.find((d : any) => d.dataIndex === 'user_role')?.value);
    } else if(col.type.includes("DRPDWN") && ['secondary_office_name'].includes(col.dataIndex)){
      errorMessage = secondaryOfficeValidation(col.value, col.displayName , data.find((d : any) => d.dataIndex === 'office_name') , data.find((d : any) => d.dataIndex === 'user_role')?.value);
    }
    return errorMessage;
  };

  const validateFields = (data: any , action : string) => {
    console.log("userManagment.validateFields")
    const validationData = cloneDeep(data).map((col: any) => {
      col.errorMessage = validateField(data , col);
      return col;
    });
    formValidationError.current = validationData.some((data: any) => data?.errorMessage?.length > 0);
    if (action === "ADD") {
      setCreateUserFields(validationData);
    } else if(action === "EDIT"){
      setEditUserFields(validationData);
    }
  };

  const emptyUserFields = (data: Array<any>, setFunc: any) => {
    console.log("userManagment.emptyUserFields")
    const formData = cloneDeep(data);
    formData.forEach((col: any) => {col.value = undefined;col.errorMessage = "";col.className=''});
    setFunc(formData);
  };

  const getPatientAssignment = () => {
    console.log("userManagment.getPatientAssignment")
    setPatientAssignmentDisabled(true);
    UserManagementService.getPatientAssignment().subscribe({
      next: (res: any) => {
        setPatientAssignmentDisabled(false);
      },
      error: () => {
        console.log("error");
        setPatientAssignmentDisabled(false);
      },
    });
  }

  const onSave = (action: string) => {
    console.log("userManagment.onSave")
    if (action === "ADD") {
      validateFields(createUserFields , action);
      if (!formValidationError.current) {
        setSaveButtonLoading(true);
        const createData = formatUserData(createUserFields, "ADD");
        UserManagementService.createUser(createData).subscribe({
          next: (res: any) => {
            const data = cloneDeep(usersData);
            data.push({user_id : usersData[usersData.length -1].user_id + 1 , ...createData , is_active : 'Y'})
            setUsersData(data);
            setIsAddUserModalOpen(false);
            setSaveButtonLoading(false);
            emptyUserFields(createUserFields, setCreateUserFields);
            formValidationError.current = false;
            if(res.data.data.type && res.data.data.message)
            notification.success({
              type : res.data.data.type,
              message : res.data.data.message
            })
          },
          error: () => {
            console.log("error");
            setIsAddUserModalOpen(false);
            setSaveButtonLoading(false);
            emptyUserFields(createUserFields, setCreateUserFields);
            formValidationError.current = false;
          },
        });
      }
    } else if (action === "EDIT") {
      validateFields(editUserFields, action);
      if (!formValidationError.current) {
        setSaveButtonLoading(true);
        UserManagementService.editUser(formatUserData(editUserFields, "EDIT")).subscribe({
          next: (res: any) => {
            const data = cloneDeep(usersData);
            const user = data.find((d) => d.user_email === editRowData.user_email);
            for (let i = 0; i < editUserFields.length; i++) {
              user[editUserFields[i].dataIndex] = editUserFields[i].value;
            }
            data[data.findIndex((d) => d.user_email === user.user_email)] = user;
            data[data.findIndex((d) => d.user_email === user.user_email)].user_role = dropdownData[dropdownData.findIndex((d : any) => d.dropdownName === 'user_role')]?.data?.find((da : any) => da?.value === user['user_role'])?.title 
            setUsersData(data);
            setisEditUserModalOpen(false);
            setSaveButtonLoading(false);
            emptyUserFields(editUserFields, setEditUserFields);
            formValidationError.current = false;
            if(res.data.data.type && res.data.data.message)
            notification.success({
              type : res.data.data.type,
              message : res.data.data.message
            })
          },
          error: () => {
            console.log("error");
            setisEditUserModalOpen(false);
            setSaveButtonLoading(false);
            emptyUserFields(editUserFields, setEditUserFields);
            formValidationError.current = false;
          },
        });
      }
    }
  };

  const onCancel = (action: string) => {
    console.log("userManagment.onCancel")
    if (action === "ADD") {
      emptyUserFields(createUserFields, setCreateUserFields);
      formValidationError.current = false;
    } else if (action === "EDIT") {
      emptyUserFields(editUserFields, setEditUserFields);
      formValidationError.current = false;
    }
  };

  const handleOk = () => {
    console.log("userManagment.handleOk")
    getPatientAssignment();
    setIsModalVisible(false);
  }

  return (
    <div className="user_management">
      {createUserFields.length > 0 ? <div className="user_management__btns">
      <div className="flex-col-dir">
        <CanEdit>
      <Button
          type="primary"
          loading={false}
          onClick={() => {
            setIsModalVisible(true);
          }}
          className="user_management__btns_patient_assignment--btn"
          //made Patient Assignment True based on Abhijit's Suggestion
          disabled = {true || patientAssignmentDisabled}
        >
          Patient Assignment
      </Button>
      </CanEdit>
      {patientAssignmentDisabled && <span className="fs-11"><span className="icon icon-info clr-lightGrayColor" style={{marginRight :"3px"}}></span>Patient Assignment is In Progess</span>}
      </div> 
      <CanEdit>
       <Button
          type="primary"
          icon={<PlusCircleOutlined />}
          loading={false}
          onClick={() => {
            setIsAddUserModalOpen(true);
          }}
          className="user_management__btns_add--btn"
        >
          Add User
        </Button> 
      </CanEdit>
      </div> : <div className="user_management__btns">
        <div className="user_management__btns_patient_assignment--btn user_management__btns_patient_assignment--btn_preloader shimmerBG">
        </div>
        <div className="user_management__btns_add--btn user_management__btns_add--btn_preloader shimmerBG">
        </div>
      </div>}
      <TableComponent
        usersData={usersData}
        columnData={columnData}
        setisEditUserModalOpen={setisEditUserModalOpen}
        editUserFields={editUserFields}
        setEditUserFields={setEditUserFields}
        setEditRowData={setEditRowData}
        dropdownData={dropdownData}
      />
      <FormModal
        setUserModalOpen={setIsAddUserModalOpen}
        title={"Add User"}
        isModalOpen={isAddUserModalOpen}
        onUserFieldChange={onUserFieldChange}
        dropdownData={dropdownData}
        fields={createUserFields}
        action={"ADD"}
        onSave={onSave}
        isLoading={saveButtonLoading}
        onCancel={onCancel}
        formValidationError={formValidationError}
        validateField={validateField}
      />
      <FormModal
        setUserModalOpen={setisEditUserModalOpen}
        title={"Edit User"}
        isModalOpen={isEditUserModalOpen}
        onUserFieldChange={onUserFieldChange}
        dropdownData={dropdownData}
        fields={editUserFields}
        action={"EDIT"}
        onSave={onSave}
        isLoading={saveButtonLoading}
        onCancel={onCancel}
        formValidationError={formValidationError}
        validateField={validateField}
      />
      <ModalCustom title={"Alert"} visible={isModalVisible} width={500}  onOk={handleOk} setVisible ={setIsModalVisible} zIndex={2}
       cancelText={"Cancel"} text={`Patient Assignmment is a batch process it will take 10 to 20 minutes do you wish to continue ?`}/>
    </div>
  );
};

export default UserManagement;
